import type {
  ReviewItem,
  WorkflowReviewStatusData,
} from '@app/shared/types/sf-data'

import { defineStore } from 'pinia'
import { ref, toRaw } from 'vue'
import isEqual from 'lodash/isEqual'

import { getReviewItemKey } from '@app/application/workflows/screens/workflow-review/utils'

export const useWorkflowReviewItemStatus = defineStore(
  'workflowReviewItemStatus',
  () => {
    const reviewItemStatus = ref<Record<string, WorkflowReviewStatusData>>({})

    function receiveItemStatuses(reviewItems: ReviewItem[]): void {
      reviewItems.forEach((reviewItem) => {
        const key = getReviewItemKey({
          itemClass: reviewItem.itemClass,
          id: reviewItem.id,
        })

        if (reviewItem.workflowReviewStatusData) {
          const { review, reviews, ...rest } =
            reviewItem.workflowReviewStatusData

          const newStatus = {
            review,
            reviews,
            ...Object.freeze(rest),
          }

          if (!isEqual(toRaw(reviewItemStatus.value[key]), newStatus)) {
            reviewItemStatus.value[key] = newStatus
          }
        }
      })
    }

    function updateReviewItemStatus({
      parentId,
      itemClass,
      reviews,
      review,
      ...rest
    }: WorkflowReviewStatusData & {
      parentId: number
    }): void {
      const key = getReviewItemKey({
        itemClass,
        id: parentId,
      })

      const previousReviewItemStatus = reviewItemStatus.value[key]

      const newStatus = {
        ...previousReviewItemStatus,
        ...rest,
        itemClass,
        review,
        reviews,
      }

      if (!isEqual(toRaw(reviewItemStatus.value[key]), newStatus)) {
        reviewItemStatus.value[key] = newStatus
      }
    }

    return {
      receiveItemStatuses,
      reviewItemStatus,
      updateReviewItemStatus,
    }
  }
)
